import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import AppOverlay from '../../components/Overlay/Overlay';
import LoginBackgroundURL from '../../assets/img/bg-login.jpeg';

export const getOverlayLabel = (phase) => {
    if (phase === 0) {
        return 'Leaving...';
    }
    return `Leaving in ${phase} second${phase === 1 ? '' : 's'}`;
}

const SignOut = () => {
    const [phase, setPhase] = useState(4);
    const [workingId, setWorkingId] = useState(false);
    const [message, setMessage] = useState(null);
    const navigateManager = useNavigate();
    const handleCompleteLeave = () => {
        window.localStorage.clear();
        const { origin, pathname } = window.location;
        window.location.href = origin + pathname;
    };
    const handleNextPhase = () => {
        if (workingId) return;
        let message = getOverlayLabel(phase);
        message = (
            phase > 0 ?
            <>
                {message}
                <Button className="d-block mt-3" style={{width: '100%'}} onClick={() => navigateManager('/')}>Cancel</Button>
            </> :
            message
        );
        setMessage(message);
        const id = setTimeout(() => {
            setWorkingId(null);
            setPhase(phase - 1);
        }, 1000);
        setWorkingId(id);
    };
    useEffect(() => {
        if (phase === -1) return handleCompleteLeave();
        if (!workingId) {
            handleNextPhase();
        }
        return function () {
            if (workingId)
            clearTimeout(workingId);
        };
    }, [phase]);
    return (
         <>
            <div className="app-background-img" style={{backgroundImage: `url(${LoginBackgroundURL})`}} />
            <AppOverlay show label={message} />
        </>
    );
}

export default SignOut;